import { render, staticRenderFns } from "./LaneClosureRequestBlockRestrictionListing.vue?vue&type=template&id=12e83465&"
import script from "./LaneClosureRequestBlockRestrictionListing.vue?vue&type=script&lang=js&"
export * from "./LaneClosureRequestBlockRestrictionListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports